import { render, staticRenderFns } from "./ContractLayoutCreate.vue?vue&type=template&id=63ef1282&"
import script from "./ContractLayoutCreate.vue?vue&type=script&lang=js&"
export * from "./ContractLayoutCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports